<template>
  <div>
    <label class="block text-sm font-medium text-gray-700 mb-2">
      What programs are you interested in? (Check all that apply)
    </label>
    <div class="space-y-2">
      <div class="flex items-center">
        <input 
          type="checkbox" 
          id="jiuJitsu" 
          v-model="selectedPrograms.jiuJitsu"
          class="h-4 w-4 text-black focus:ring-black border-gray-300 rounded"
        >
        <label for="jiuJitsu" class="ml-2 text-sm text-gray-700">Jiu Jitsu</label>
      </div>
      <div class="flex items-center">
        <input 
          type="checkbox" 
          id="wrestling" 
          v-model="selectedPrograms.wrestling"
          class="h-4 w-4 text-black focus:ring-black border-gray-300 rounded"
        >
        <label for="wrestling" class="ml-2 text-sm text-gray-700">Wrestling</label>
      </div>
      <div class="flex items-center">
        <input 
          type="checkbox" 
          id="kidsPrograms" 
          v-model="selectedPrograms.kidsPrograms"
          class="h-4 w-4 text-black focus:ring-black border-gray-300 rounded"
        >
        <label for="kidsPrograms" class="ml-2 text-sm text-gray-700">Kids Programs</label>
      </div>
      <div class="flex items-center">
        <input 
          type="checkbox" 
          id="muayThai" 
          v-model="selectedPrograms.muayThai"
          class="h-4 w-4 text-black focus:ring-black border-gray-300 rounded"
        >
        <label for="muayThai" class="ml-2 text-sm text-gray-700">Muay Thai</label>
      </div>
      <div class="flex items-center">
        <input 
          type="checkbox" 
          id="strength" 
          v-model="selectedPrograms.strength"
          class="h-4 w-4 text-black focus:ring-black border-gray-300 rounded"
        >
        <label for="strength" class="ml-2 text-sm text-gray-700">Strength and Conditioning</label>
      </div>
      <div class="flex items-center">
        <input 
          type="checkbox" 
          id="personalTraining" 
          v-model="selectedPrograms.personalTraining"
          class="h-4 w-4 text-black focus:ring-black border-gray-300 rounded"
        >
        <label for="personalTraining" class="ml-2 text-sm text-gray-700">Personal Training/Private Sessions</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AvailablePrograms',
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  computed: {
    selectedPrograms: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  emits: ['update:modelValue']
}
</script> 